import React from 'react';

import Cookie from 'js-cookie';
import { createRoot } from 'react-dom/client';

import { LOCAL_STORAGE_APP_FIRST_ACCESS, LOCAL_STORAGE_APP_NOT_FIRST_ACCESS } from '../../../constants/Home';
import { APP_UPGRADE_WEBVIEW, APP_FIRST_ACCESS } from '../../../constants/Metrics';

import MetricsService from '../../../services/Api/Metrics';

import HomeManagment from '../HomeManagment/HomeManagment';

const isMaintenance = (() => {
    const elemMaintenanceMode = document.querySelector('meta[name="maintenance-mode"]');
    return !!elemMaintenanceMode && !!elemMaintenanceMode.content;
})();

const webviewMetrics = () => {
    const elemWebview = document.querySelector('meta[name="webview-token"]');
    if (!elemWebview) return;

    const webviewToken = elemWebview.content;
    const metricsService = new MetricsService();
    metricsService.setMetricsWithoutJWT(webviewToken, APP_UPGRADE_WEBVIEW.FEATURE, APP_UPGRADE_WEBVIEW.CATEGORY_B);
};

const firstAccessControl = () => {
    const hasLogged = localStorage.getItem(LOCAL_STORAGE_APP_NOT_FIRST_ACCESS) || Cookie.get('ast_logged');
    const hasFirstAccess = localStorage.getItem(LOCAL_STORAGE_APP_FIRST_ACCESS);

    if (hasFirstAccess || hasLogged) {
        localStorage.removeItem(LOCAL_STORAGE_APP_FIRST_ACCESS);
        localStorage.setItem(LOCAL_STORAGE_APP_NOT_FIRST_ACCESS, true);
        return;
    }

    localStorage.setItem(LOCAL_STORAGE_APP_FIRST_ACCESS, true);
    const metricsService = new MetricsService();
    metricsService.setMetricsWithoutJWT('app-first-access', APP_FIRST_ACCESS.FEATURE, APP_FIRST_ACCESS.ACCESS);
};

const getProperty = (element, property) => {
    if (!element) return null;

    const { dataset } = element;

    return dataset[property] ? dataset[property] : element.getAttribute(property);
};

if (document.getElementById('presentation__swipe') && !isMaintenance) {
    webviewMetrics();
    firstAccessControl();

    const element = document.getElementById('auth');

    const urlGoogle = getProperty(element, 'urlGoogle');
    const errorMessage = getProperty(element, 'errorMessage');

    createRoot(document.getElementById('presentation__swipe')).render(
        <HomeManagment maintenance={isMaintenance} errorMessage={errorMessage} urlGoogle={urlGoogle} />
    );
}
